import './footer.css'
import { Link } from 'react-router-dom';

function Footer({contact, home, resume}) {
    const currentYear = new Date().getFullYear();

    return (
        <div className='footerContainer'>
            <hr></hr>
            <div className='textContainer'>
                <p>© {currentYear}  -  Andres Torres</p>
                <div className='link-container'>
                {contact && (
                    <Link to="/contact" className='contactCTA'>
                        {contact}
                    </Link>
                )}
                {home && (
                    <Link to="/" className='contactCTA'>
                        {home}
                    </Link>
                )}
                {resume && (
                    <Link to="/resume" className='contactCTA'>
                        {resume}
                    </Link>
                )}
                </div>
            </div>
        </div>

    )
}

export default Footer;